import { createRequest } from './createRequest'

export const forgotPasswordPath = '/forgot-password'

export const forgotPassword = createRequest({ path: forgotPasswordPath })
